import {
    Button,
    CircularProgress,
    Grid,
    Paper,
    Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { url } from "../../baseUrl";
import { useSelector } from "react-redux";
import axios from "axios";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import MailIcon from "@mui/icons-material/Mail";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import ReceiptIcon from "@mui/icons-material/Receipt";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import LockIcon from "@mui/icons-material/Lock";
import SecurityIcon from "@mui/icons-material/Security";
import CustomizedSnackbars from "../../Components/SnackBar/SnackBar";
import StripeCardForm from "../../Components/StripeCardForm/StripeCardForm";
import "./invoice.css";
import logo from "../../Assets/images/logo.webp";
import stripeBadge from "../../Assets/images/stripebadge.png";
import ssl from "../../Assets/images/ssl.png";
import norton from "../../Assets/images/norton.png";
import visa from "../../Assets/images/visa.png";
import masterCard from "../../Assets/images/masterCard.png";

// ─── E‑ComSnaps Brand Colors ───────────────────────────────
const brand = {
    primary: "#0006df",
    primaryDark: "#0a0fca",
    white: "#ffffff",
    lightGray: "#f4f6fc",
    darkText: "#1e293b",
    lightText: "#6b7280",
    border: "#e5e7eb",
    success: "#10b981",
    gradient: "linear-gradient(180deg, #0a0fca 0%, #ffffff 100%)",
    gradientCard: "linear-gradient(145deg, #0a0fca 0%, #0006df 100%)",
    shadow: "0 20px 60px rgba(0, 6, 223, 0.08)",
    cardShadow: "0 10px 40px rgba(0,0,0,0.06)",
};

// ─── Helper: Convert to USA Time ─────────────────────────────
const convertToUSATime = (dateTime) => {
    if (!dateTime) return '—';
    try {
        const date = new Date(dateTime);
        return date.toLocaleString('en-US', {
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        });
    } catch (e) {
        return dateTime;
    }
};

// ─── Component ──────────────────────────────────────────────────
const InvoicePage = () => {
    let { id } = useParams();
    let param = id.split("_");
    const state = useSelector((state) => state.user.data);

    const [data, setData] = useState();
    const [key, setKey] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isPaid, setIsPaid] = useState(false);

    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [severity, setSeverity] = useState("");

    let invoiceId = param[0];

    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    });

    useEffect(() => {
        getSpecificTransaction();
        // eslint-disable-next-line
    }, []);

    const getSpecificTransaction = async () => {
        setIsLoading(false);
        await axios
            .post(`${url}/transactions/getSpecificTransaction`, {
                _id: invoiceId,
            })
            .then((response) => {
                setData(response.data.data[0]);
                setKey(response.data.key.publishKey);
                if (response.data.data[0].paymentStatus) {
                    setIsPaid(true);
                } else {
                    setIsPaid(false);
                }
                setIsLoading(true);
            });
    };

    return (
        <>
            {isLoading ? (
                <>
                    {/* ─── HEADER ─────────────────────────────────────────── */}
                    <Grid
                        container
                        xs={12}
                        sx={{
                            height: "72px",
                            background: brand.white,
                            position: "sticky",
                            top: 0,
                            zIndex: 1000,
                            boxShadow: "0 2px 24px rgba(0,6,223,0.08)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderBottom: `2px solid ${brand.primary}`,
                        }}
                    >
                        <Grid
                            item
                            xs={12}
                            sx={{
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <img
                                src={logo}
                                height="50px"
                                alt="ecomsnaps"
                                className="header-logo"
                                style={{ objectFit: "contain" }}
                            />
                        </Grid>
                    </Grid>

                    {/* ─── MAIN CONTENT ────────────────────────────────────── */}
                    <Grid
                        container
                        sx={{
                            minHeight: "calc(100vh - 72px)",
                            background: brand.gradient,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: { xs: "20px 12px", md: "40px 20px" },
                        }}
                    >
                        <Grid
                            container
                            spacing={{ xs: 3, md: 5 }}
                            maxWidth="lg"
                            justifyContent="center"
                            alignItems="center"
                        >
                            {/* ─── LEFT COLUMN – INVOICE CARD (WHITE) ─────── */}
                            <Grid item md={6} xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                                <Paper
                                    sx={{
                                        background: brand.white,
                                        borderRadius: "28px",
                                        boxShadow: brand.cardShadow,
                                        p: { xs: 3, md: 4.5 },
                                        width: "100%",
                                        maxWidth: "500px",
                                        position: "relative",
                                        alignSelf: "center",
                                        border: `1px solid ${brand.border}`,
                                    }}
                                >
                                    {/* Header */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "flex-start",
                                            mb: 4,
                                            position: "relative",
                                            zIndex: 1,
                                            flexWrap: "wrap",
                                            gap: 1,
                                        }}
                                    >
                                        <Box>
                                            <Typography
                                                variant="h4"
                                                sx={{
                                                    color: brand.darkText,
                                                    fontWeight: 700,
                                                    mb: 0.5,
                                                    letterSpacing: "-0.5px",
                                                }}
                                            >
                                                Invoice
                                            </Typography>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 1,
                                                }}
                                            >
                                                <ReceiptIcon
                                                    sx={{
                                                        color: brand.primary,
                                                        fontSize: 18,
                                                    }}
                                                />
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: brand.lightText,
                                                        fontFamily: "monospace",
                                                        letterSpacing: "0.5px",
                                                    }}
                                                >
                                                    #{data.orderId}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box
                                            sx={{
                                                background: data.paymentStatus
                                                    ? brand.success
                                                    : brand.primary,
                                                px: 3,
                                                py: 1,
                                                borderRadius: "40px",
                                                boxShadow: data.paymentStatus
                                                    ? "0 4px 20px rgba(16,185,129,0.3)"
                                                    : "0 4px 20px rgba(0,6,223,0.25)",
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: brand.white,
                                                    fontWeight: 700,
                                                    letterSpacing: "1px",
                                                    fontSize: "11px",
                                                }}
                                            >
                                                {data.paymentStatus ? "✓ PAID" : "PENDING"}
                                            </Typography>
                                        </Box>
                                    </Box>

                                    {/* Billed to */}
                                    <Box sx={{ mb: 4, position: "relative", zIndex: 1 }}>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: brand.lightText,
                                                mb: 1.5,
                                                letterSpacing: "2px",
                                                fontSize: "11px",
                                                fontWeight: 600,
                                            }}
                                        >
                                            BILLED TO
                                        </Typography>
                                        <Typography
                                            variant="h5"
                                            sx={{
                                                color: brand.darkText,
                                                fontWeight: 700,
                                                mb: 2,
                                                letterSpacing: "-0.3px",
                                            }}
                                        >
                                            {data.custName}
                                        </Typography>

                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 1.5,
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 2,
                                                }}
                                            >
                                                <EmailIcon
                                                    sx={{
                                                        color: brand.primary,
                                                        fontSize: 18,
                                                    }}
                                                />
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: brand.darkText,
                                                        opacity: 0.9,
                                                    }}
                                                >
                                                    {data.custEmail}
                                                </Typography>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 2,
                                                }}
                                            >
                                                <PhoneIcon
                                                    sx={{
                                                        color: brand.primary,
                                                        fontSize: 18,
                                                    }}
                                                />
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: brand.darkText,
                                                        opacity: 0.9,
                                                    }}
                                                >
                                                    {data.custContactNumber}
                                                </Typography>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 2,
                                                }}
                                            >
                                                <CalendarTodayIcon
                                                    sx={{
                                                        color: brand.primary,
                                                        fontSize: 18,
                                                    }}
                                                />
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: brand.darkText,
                                                        opacity: 0.9,
                                                    }}
                                                >
                                                    {/* ─── USA TIME ────────────────────────── */}
                                                    {convertToUSATime(data.dateTime)}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>

                                    <Box
                                        sx={{
                                            borderTop: `1px solid ${brand.border}`,
                                            my: 3,
                                            position: "relative",
                                            zIndex: 1,
                                        }}
                                    />

                                    {/* Items */}
                                    <Box sx={{ position: "relative", zIndex: 1 }}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                mb: 2,
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: brand.lightText,
                                                    fontWeight: 600,
                                                    letterSpacing: "1px",
                                                    fontSize: "11px",
                                                }}
                                            >
                                                DESCRIPTION
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: brand.lightText,
                                                    fontWeight: 600,
                                                    letterSpacing: "1px",
                                                    fontSize: "11px",
                                                }}
                                            >
                                                AMOUNT
                                            </Typography>
                                        </Box>

                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                py: 2,
                                                borderBottom: `1px solid ${brand.border}`,
                                            }}
                                        >
                                            <Box>
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        color: brand.darkText,
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    {data.discription}
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: brand.lightText,
                                                        mt: 0.5,
                                                        fontSize: "13px",
                                                    }}
                                                >
                                                    {data.detailDiscription}
                                                </Typography>
                                            </Box>
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    color: brand.darkText,
                                                    fontWeight: 600,
                                                }}
                                            >
                                                {formatter.format(data.amount)}
                                            </Typography>
                                        </Box>

                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                py: 2,
                                                borderBottom: `1px solid ${brand.border}`,
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: brand.darkText,
                                                    opacity: 0.7,
                                                }}
                                            >
                                                <LocalOfferIcon
                                                    sx={{
                                                        color: brand.primary,
                                                        fontSize: 16,
                                                        mr: 1,
                                                        verticalAlign: "middle",
                                                    }}
                                                />
                                                Discount
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                sx={{ color: "#ef4444" }}
                                            >
                                                -{formatter.format(data.discount)}
                                            </Typography>
                                        </Box>

                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                py: 2,
                                                borderBottom: `1px solid ${brand.border}`,
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: brand.darkText,
                                                    opacity: 0.7,
                                                }}
                                            >
                                                <AccountBalanceWalletIcon
                                                    sx={{
                                                        color: brand.primary,
                                                        fontSize: 16,
                                                        mr: 1,
                                                        verticalAlign: "middle",
                                                    }}
                                                />
                                                Taxes & Fees
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: brand.darkText,
                                                    opacity: 0.9,
                                                }}
                                            >
                                                {formatter.format(data.additionalCharges)}
                                            </Typography>
                                        </Box>

                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                pt: 3,
                                                mt: 1,
                                            }}
                                        >
                                            <Typography
                                                variant="h5"
                                                sx={{
                                                    color: brand.darkText,
                                                    fontWeight: 700,
                                                }}
                                            >
                                                Total Amount
                                            </Typography>
                                            <Typography
                                                variant="h4"
                                                sx={{
                                                    color: brand.primary,
                                                    fontWeight: 800,
                                                    letterSpacing: "-0.5px",
                                                }}
                                            >
                                                {formatter.format(data.total)}
                                            </Typography>
                                        </Box>
                                    </Box>

                                    {/* Footer inside invoice */}
                                    <Box
                                        sx={{
                                            mt: 4,
                                            pt: 3,
                                            borderTop: `1px solid ${brand.border}`,
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            position: "relative",
                                            zIndex: 1,
                                            flexWrap: "wrap",
                                            gap: 1,
                                        }}
                                    >
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <SecurityIcon
                                                sx={{
                                                    color: brand.primary,
                                                    fontSize: 18,
                                                }}
                                            />
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    color: brand.lightText,
                                                    fontSize: "11px",
                                                    fontWeight: 500,
                                                }}
                                            >
                                                256-bit encrypted
                                            </Typography>
                                        </Box>
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                color: brand.lightText,
                                                fontSize: "10px",
                                                fontWeight: 400,
                                            }}
                                        >
                                            E‑ComSnaps • secure
                                        </Typography>
                                    </Box>
                                </Paper>
                            </Grid>

                            {/* ─── RIGHT COLUMN – PAYMENT FORM ────────────── */}
                            <Grid item md={6} xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                                <Paper
                                    sx={{
                                        background: brand.white,
                                        borderRadius: "28px",
                                        boxShadow: brand.cardShadow,
                                        p: { xs: 3, md: 4.5 },
                                        width: "100%",
                                        maxWidth: "500px",
                                        alignSelf: "center",
                                        border: `1px solid ${brand.border}`,
                                    }}
                                >
                                    <Typography
                                        variant="h5"
                                        sx={{
                                            color: brand.primary,
                                            fontWeight: 700,
                                            mb: 0.5,
                                            letterSpacing: "-0.3px",
                                        }}
                                    >
                                        Complete Payment
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: brand.lightText,
                                            mb: 4,
                                        }}
                                    >
                                        Secure your order by completing the payment below
                                    </Typography>

                                    {/* Amount pill – blue gradient */}
                                    <Box
                                        sx={{
                                            background: brand.gradientCard,
                                            p: 3,
                                            borderRadius: "20px",
                                            mb: 4,
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            boxShadow: "0 8px 30px rgba(0,6,223,0.15)",
                                        }}
                                    >
                                        <Box>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: brand.white,
                                                    opacity: 0.75,
                                                    fontWeight: 500,
                                                }}
                                            >
                                                Amount to Pay
                                            </Typography>
                                            <Typography
                                                variant="h4"
                                                sx={{
                                                    color: brand.white,
                                                    fontWeight: 700,
                                                    letterSpacing: "-0.5px",
                                                }}
                                            >
                                                {formatter.format(data.total)}
                                            </Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                background: brand.white,
                                                px: 3,
                                                py: 1.5,
                                                borderRadius: "40px",
                                                boxShadow: "0 4px 20px rgba(255,255,255,0.25)",
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: brand.primary,
                                                    fontWeight: 700,
                                                    letterSpacing: "1px",
                                                }}
                                            >
                                                USD
                                            </Typography>
                                        </Box>
                                    </Box>

                                    {isPaid ? (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                background:
                                                    "linear-gradient(145deg, #10b981 0%, #059669 100%)",
                                                color: brand.white,
                                                p: 4,
                                                borderRadius: "20px",
                                                gap: 2,
                                                boxShadow:
                                                    "0 8px 30px rgba(16,185,129,0.25)",
                                            }}
                                        >
                                            <CheckCircleOutlineIcon
                                                sx={{ fontSize: 64 }}
                                            />
                                            <Typography
                                                variant="h5"
                                                sx={{ fontWeight: 700 }}
                                            >
                                                Payment Successful!
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                sx={{ opacity: 0.9 }}
                                            >
                                                Thank you for your payment
                                            </Typography>
                                            {/* ─── PAYMENT TIME IN USA ───────────────── */}
                                            <Typography variant="caption" sx={{ opacity: 0.7, mt: 1 }}>
                                                Paid on: {convertToUSATime(data.paymentTime)}
                                            </Typography>
                                        </Box>
                                    ) : (
                                        <>
                                            <StripeCardForm
                                                transactionId={invoiceId}
                                                amount={Number(data.total)}
                                                account={data.account}
                                                stripeKey={key}
                                            />

                                            {/* Security badges */}
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    mt: 4,
                                                    flexWrap: "wrap",
                                                    gap: 2.5,
                                                    alignItems: "center",
                                                }}
                                            >
                                                <img
                                                    src={stripeBadge}
                                                    height="34px"
                                                    alt="Stripe"
                                                />
                                                <img
                                                    src={ssl}
                                                    height="34px"
                                                    alt="SSL"
                                                />
                                                <img
                                                    src={norton}
                                                    height="34px"
                                                    alt="Norton"
                                                />
                                                <img
                                                    src={visa}
                                                    height="24px"
                                                    alt="Visa"
                                                />
                                                <img
                                                    src={masterCard}
                                                    height="22px"
                                                    alt="Mastercard"
                                                />
                                            </Box>

                                            {/* Contact */}
                                            <Box
                                                sx={{
                                                    mt: 4,
                                                    pt: 3,
                                                    borderTop: `2px solid ${brand.border}`,
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    gap: 4,
                                                    flexWrap: "wrap",
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1.5,
                                                    }}
                                                >
                                                    <MailIcon
                                                        sx={{
                                                            color: brand.primary,
                                                            fontSize: 20,
                                                        }}
                                                    />
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            color: brand.lightText,
                                                            fontSize: "13px",
                                                        }}
                                                    >
                                                        support@ecomsnaps.com
                                                    </Typography>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1.5,
                                                    }}
                                                >
                                                    <LocalPhoneIcon
                                                        sx={{
                                                            color: brand.primary,
                                                            fontSize: 20,
                                                        }}
                                                    />
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            color: brand.lightText,
                                                            fontSize: "13px",
                                                        }}
                                                    >
                                                        +1 305 396-1171
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            {/* Lock footer */}
                                            <Box
                                                sx={{
                                                    mt: 3,
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    gap: 1,
                                                }}
                                            >
                                                <LockIcon
                                                    sx={{
                                                        color: brand.primary,
                                                        fontSize: 16,
                                                        opacity: 0.5,
                                                    }}
                                                />
                                                <Typography
                                                    variant="caption"
                                                    sx={{
                                                        color: brand.lightText,
                                                        fontSize: "12px",
                                                        opacity: 0.6,
                                                    }}
                                                >
                                                    Secured with 256-bit encryption
                                                </Typography>
                                            </Box>
                                        </>
                                    )}
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* ─── FOOTER ──────────────────────────────────────────── */}
                    <Grid
                        container
                        xs={12}
                        sx={{
                            background: brand.primaryDark,
                            py: 3,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderTop: `2px solid ${brand.white}`,
                        }}
                    >
                        <Typography
                            variant="body2"
                            sx={{
                                color: brand.white,
                                textAlign: "center",
                                opacity: 0.7,
                                fontSize: "14px",
                                fontWeight: 400,
                            }}
                        >
                            © {new Date().getFullYear()} E‑ComSnaps. All Rights Reserved.
                        </Typography>
                    </Grid>
                </>
            ) : (
                // ─── LOADER ────────────────────────────────────────────────
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh",
                        flexDirection: "column",
                        gap: 3,
                        background: brand.gradient,
                    }}
                >
                    <CircularProgress sx={{ color: brand.primary }} />
                    <Typography
                        variant="h6"
                        sx={{
                            color: brand.primary,
                            fontWeight: 600,
                            letterSpacing: "-0.3px",
                        }}
                    >
                        Loading Invoice…
                    </Typography>
                </Box>
            )}

            <CustomizedSnackbars
                isOpen={isOpen}
                severity={severity}
                message={message}
            />
        </>
    );
};

export default InvoicePage;